import { render, staticRenderFns } from "./FloatingIcon1.vue?vue&type=template&id=449453ec&scoped=true"
import script from "./FloatingIcon1.vue?vue&type=script&lang=js"
export * from "./FloatingIcon1.vue?vue&type=script&lang=js"
import style0 from "./FloatingIcon1.vue?vue&type=style&index=0&id=449453ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449453ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsVerticalFloatingIcons: require('/app/components/Commons/VerticalFloatingIcons.vue').default})
